import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../../../../types"
import { getServiceErrorMessage } from "../../../../helpers"

export const togglePublishedPlanBreakBeforeSectionTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    src: "togglePublishedPlanBreakBeforeSection",
    onDone: {
      target: "#StudyPlan.get_current_plan"
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("toggleBreakBeforeSection", {
            messageData: ["toggle break before section"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
